import {City} from "./city.model";

export interface State {
  id: number,
  name: string,
  abbr: string,
  country_id: number,
  cities?: City[]
}
